export default __webpack_public_path__ + "static/media/card.460e7ce5.png";